import { initializeApp, getApps, getApp } from 'firebase/app';
import { 
  getAuth, 
  GoogleAuthProvider, 
  signInWithPopup, 
  signInWithRedirect,
  getRedirectResult,
  signOut as firebaseSignOut 
} from 'firebase/auth';

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY || "AIzaSyC0J8o2VlBmwlqhPEX1FRbmpBMIKgJvdyY",
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN || "yegonews-portal-app.firebaseapp.com",
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID || "yegonews-portal-app",
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET || "yegonews-portal-app.firebasestorage.app",
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID || "600447763240",
  appId: process.env.REACT_APP_FIREBASE_APP_ID || "1:600447763240:web:4dcd07c7bfbd80ce2a061d"
};

// Initialize Firebase
const app = getApps().length === 0 ? initializeApp(firebaseConfig) : getApp();
const auth = getAuth(app);

// Google Auth Provider
const googleProvider = new GoogleAuthProvider();
googleProvider.setCustomParameters({
  prompt: 'select_account'
});

export const signInWithGooglePopup = async () => {
  try {
    const result = await signInWithPopup(auth, googleProvider);
    const idToken = await result.user.getIdToken();
    return {
      user: result.user,
      idToken
    };
  } catch (error) {
    console.error("Firebase Google Sign-In Error:", error);
    if (error.code === 'auth/popup-blocked') {
      console.log("Popup blocked, redirecting...");
      await signInWithRedirect(auth, googleProvider);
      return null;
    }
    throw error;
  }
};

export { app, auth, googleProvider, firebaseSignOut, signInWithRedirect, getRedirectResult };
export default app;
